document.addEventListener('DOMContentLoaded', function() {
  const form = document.querySelector('.wpcf7-form');
  const inputArea = document.getElementById('input-area');
  const confirmArea = document.getElementById('confirm-area');
  const confirmData = document.getElementById('confirm-data');

  const labels = {
    'your-name': 'お名前',
    'company-name': '法人名',
    'your-email': 'メールアドレス',
    'phone-number': '電話番号',
    'inquiry-content': 'お問い合わせ内容'
  };

  if (!form) return;

  let canSubmit = false;

  // Contact Form 7の送信ボタンを非表示にして、確認ボタンを追加
  const cf7SubmitButton = form.querySelector('input[type="submit"]');
  if (cf7SubmitButton) {
    cf7SubmitButton.style.display = 'none';

    // 確認ボタンを作成
    const confirmButtonWrapper = document.createElement('div');
    confirmButtonWrapper.className = 'c-mailform__submit';
    confirmButtonWrapper.innerHTML = '<p><button type="button" class="c-mailform__btn" id="confirm-button">確認する</button></p>';

    // 送信ボタンの親要素の後に挿入
    cf7SubmitButton.parentElement.parentElement.appendChild(confirmButtonWrapper);
  }

  // Contact Form 7のsubmitイベント制御
  form.addEventListener('submit', function(e) {
    if (!canSubmit) {
      e.preventDefault();
      e.stopPropagation();
      return false;
    }
  }, true);

  // エラー表示をクリア
  function clearValidationErrors() {
    const notValidElements = form.querySelectorAll('.wpcf7-not-valid');
    notValidElements.forEach(el => {
      el.classList.remove('wpcf7-not-valid');
      el.removeAttribute('aria-invalid');
      const wrap = el.closest('.wpcf7-form-control-wrap');
      if (wrap) {
        const validationError = wrap.querySelector('.wpcf7-not-valid-tip');
        if (validationError) {
          validationError.remove();
        }
      }
    });

    // プライバシーポリシーのエラーメッセージをクリア
    const privacyContainer = form.querySelector('.c-mailform__privacy');
    if (privacyContainer && privacyContainer.nextElementSibling) {
      if (privacyContainer.nextElementSibling.classList.contains('wpcf7-not-valid-tip')) {
        privacyContainer.nextElementSibling.remove();
      }
    }
  }

  // 確認ボタン
  document.getElementById('confirm-button').addEventListener('click', function() {
    clearValidationErrors();

    const hasError = validateForm();

    if (!hasError) {
      showConfirm();
    } else {
      scrollToFirstError();
    }
  });

  // フォームバリデーション
  function validateForm() {
    let hasError = false;

    // 必須フィールドのチェック
    const requiredFields = form.querySelectorAll('[aria-required="true"]');
    requiredFields.forEach(field => {
      if (field.type === 'checkbox' || field.type === 'radio') {
        const name = field.name;
        const checked = form.querySelector(`[name="${name}"]:checked`);
        if (!checked) {
          markFieldAsInvalid(field, 'この項目は必須項目です。');
          hasError = true;
        }
      } else if (!field.value.trim()) {
        markFieldAsInvalid(field, 'この項目は必須項目です。');
        hasError = true;
      }
    });

    // メールアドレスの形式チェック
    const emailFields = form.querySelectorAll('input[type="email"]');
    emailFields.forEach(field => {
      if (field.value.trim()) {
        const emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        if (!emailPattern.test(field.value)) {
          markFieldAsInvalid(field, 'メールアドレスの形式が正しくありません。');
          hasError = true;
        }
      }
    });

    // プライバシーポリシーのチェック
    const privacyCheckbox = form.querySelector('[name="privacy"]');
    if (privacyCheckbox && !privacyCheckbox.checked) {
      markFieldAsInvalid(privacyCheckbox, 'プライバシーポリシーに同意してください。');
      hasError = true;
    }

    return hasError;
  }

  // 最初のエラーフィールドにスクロール
  function scrollToFirstError() {
    const firstError = form.querySelector('.wpcf7-not-valid');
    if (firstError) {
      firstError.scrollIntoView({ behavior: 'smooth', block: 'center' });
    }
  }

  function markFieldAsInvalid(field, message) {
    field.classList.add('wpcf7-not-valid');
    field.setAttribute('aria-invalid', 'true');

    const wrap = field.closest('.wpcf7-form-control-wrap');
    if (wrap) {
      // 既存のエラーメッセージを削除
      const existingError = wrap.querySelector('.wpcf7-not-valid-tip');
      if (existingError) {
        existingError.remove();
      }

      // プライバシーポリシーのチェックボックスの場合
      if (field.name === 'privacy') {
        const privacyContainer = field.closest('.c-mailform__privacy');
        if (privacyContainer) {
          // .c-mailform__privacyの直後にエラーメッセージを追加
          const errorSpan = document.createElement('span');
          errorSpan.className = 'wpcf7-not-valid-tip';
          errorSpan.setAttribute('aria-hidden', 'true');
          errorSpan.textContent = message;
          privacyContainer.insertAdjacentElement('afterend', errorSpan);
          return;
        }
      }

      // 通常のフィールドの場合、wrapの中にエラーメッセージを追加
      const errorSpan = document.createElement('span');
      errorSpan.className = 'wpcf7-not-valid-tip';
      errorSpan.setAttribute('aria-hidden', 'true');
      errorSpan.textContent = message;
      wrap.appendChild(errorSpan);
    }
  }

  // 確認画面表示
  function showConfirm() {
    confirmData.innerHTML = '';
    const formData = new FormData(form);

    for (const [key, value] of formData.entries()) {
      if (labels[key] && value.trim()) {
        confirmData.innerHTML += `
          <dt class="c-mailform__label"><span class="c-mailform__label-text">${labels[key]}</span></dt>
          <dd class="c-mailform__item c-mailform__item--confirm">${value.replace(/\n/g, '<br>')}</dd>
        `;
      }
    }

    inputArea.style.display = 'none';
    confirmArea.style.display = 'block';

    // フォームセクションの先頭にスクロール
    const formSection = document.getElementById('contact-form-section');
    if (formSection) {
      formSection.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
  }

  // 戻るボタン
  const backButton = document.getElementById('back-button');
  if (backButton) {
    backButton.addEventListener('click', function() {
      confirmArea.style.display = 'none';
      inputArea.style.display = 'block';

      // フォームセクションの先頭にスクロール
      const formSection = document.getElementById('contact-form-section');
      if (formSection) {
        formSection.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }
    });
  }

  // 送信ボタン
  const submitButton = document.getElementById('submit-button');
  if (submitButton) {
    submitButton.addEventListener('click', function(e) {
      e.preventDefault();
      canSubmit = true;

      // Contact Form 7の送信ボタンをプログラムでクリック
      const cf7SubmitBtn = form.querySelector('input[type="submit"]');
      if (cf7SubmitBtn) {
        cf7SubmitBtn.style.display = 'block';
        cf7SubmitBtn.click();
        cf7SubmitBtn.style.display = 'none';
      }
    });
  }

  // 送信完了後、サンクスページへリダイレクト
  document.addEventListener('wpcf7mailsent', function(event) {
    if (canSubmit) {
      const mainElement = document.querySelector('main[data-contact-thanks-url]');
      const contactThanksUrl = mainElement ? mainElement.getAttribute('data-contact-thanks-url') : null;
      if (contactThanksUrl) {
        location.href = contactThanksUrl;
      }
    }
  });
});
